export default "__VITE_ASSET__ad6c6c6d__"